import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { openPopover } from '../../../actions/popover'
import ComposeExtraButton from './compose_extra_button'

class EmojiPickerButton extends React.PureComponent {
  handleClick = e => this.props.onClick(this.button)
  setButton = ref => (this.button = ref)
  render() {
    const { active, small } = this.props

    return (
      <ComposeExtraButton
        title='Insert Emoji'
        onClick={this.handleClick}
        icon="happy"
        active={active}
        buttonRef={this.setButton}
        small={small}
        iconClassName={_s.cIconComposeEmoji}
      />
    )
  }
}

const mapStateToProps = state => ({
  active: state.getIn(['popover', 'popoverType']) === 'EMOJI_PICKER'
})

const mapDispatchToProps = (dispatch, { composerId }) => ({
  onClick(targetRef) {
    dispatch(openPopover('EMOJI_PICKER', { targetRef, composerId }))
  }
})

EmojiPickerButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  small: PropTypes.bool,
  composerId: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(EmojiPickerButton)
